import type { GameModule } from '../../core/contracts'
import {
  INITIAL_LEVEL,
  MAX_LEVEL,
  MIN_LEVEL,
  REFERENCE_RT_MS,
  evaluate,
  generateRound,
} from './logic'
import type { StroopAnswer, StroopRound } from './logic'
import { StroopView } from './view'

/**
 * Первая игра с метрикой speed-accuracy: результат сводится через BIS.
 * До неё эта ветка скоринга была покрыта только юнит-тестами.
 */
export const stroop: GameModule<StroopRound, StroopAnswer> = {
  id: 'stroop',
  titleKey: 'game.stroop',
  hintKey: 'game.stroop.hint',
  discipline: 'attention',
  metric: 'speed-accuracy',
  difficulty: { min: MIN_LEVEL, max: MAX_LEVEL, initial: INITIAL_LEVEL },
  roundsPerSession: 4,
  referenceRtMs: REFERENCE_RT_MS,
  generateRound,
  evaluate,
  View: StroopView,
}

export * from './logic'
